import { ADMIN_SERVICE_FORM } from './index';
import { Action } from '../action';
import { AccessCodeServiceInfo } from '@shared/core';

export class AdminServiceFormInitAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormDestroyAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormClickAddOrganizationAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.CLICK_ADD_ORGANIZATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormClickAddGroupAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.CLICK_ADD_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormSelectOrganizationCodeAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.SELECT_ORGANIZATION_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminServiceFormSelectGroupCodeAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.SELECT_GROUP_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminServiceFormSelectParkAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.SELECT_PARK;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminServiceFormSelectServiceAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.SELECT_SERVICE;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminServiceFormClickSubmitAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.CLICK_SUBMIT;
	constructor(
		public payload: AccessCodeServiceInfo,
		public correlationId?: number
	) {}
}

export class AdminServiceFormUpdateAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.UPDATE;
	constructor(
		public payload: AccessCodeServiceInfo,
		public correlationId?: number
	) {}
}

export class AdminServiceFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormUpdateFailureAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminServiceFormAddAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.ADD;
	constructor(
		public payload: AccessCodeServiceInfo,
		public correlationId?: number
	) {}
}

export class AdminServiceFormAddSuccessAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.ADD_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceFormAddFailureAction implements Action {
	readonly type = ADMIN_SERVICE_FORM.ADD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
